/**
 * StopSelectionActionBar — sticky bar that appears when one or more stops are
 * checked in the multi-select. Drives the cross-route move flow.
 */

import { useRoutePlannerStore } from '../../stores/route-planner-store';

interface StopSelectionActionBarProps {
  onMoveClick: () => void;
}

export function StopSelectionActionBar({ onMoveClick }: StopSelectionActionBarProps) {
  const selectedStopIds = useRoutePlannerStore((s) => s.selectedStopIds);
  const clearStopSelection = useRoutePlannerStore((s) => s.clearStopSelection);
  const openNietGeluktDialog = useRoutePlannerStore((s) => s.openNietGeluktDialog);
  const isLocked = useRoutePlannerStore((s) => s.isLocked);

  if (selectedStopIds.size === 0) return null;

  const count = selectedStopIds.size;
  const label = count === 1 ? 'stop' : 'stops';

  return (
    <div className="sticky bottom-0 bg-white border-t border-gray-200 px-4 py-3 flex items-center justify-between gap-2 shadow-[0_-2px_8px_rgba(0,0,0,0.04)]">
      <span className="text-sm text-gray-700 shrink-0">
        <strong>{count}</strong> {label} geselecteerd
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={clearStopSelection}
          className="px-3 py-1.5 text-sm text-gray-700 bg-white border border-gray-200 rounded-md hover:bg-gray-50"
        >
          Wissen
        </button>
        <button
          type="button"
          onClick={() => openNietGeluktDialog(Array.from(selectedStopIds))}
          title="Markeer als niet gelukt vandaag — klant herplant zelf"
          className="px-3 py-1.5 text-sm font-medium text-white bg-amber-600 rounded-md hover:bg-amber-700"
        >
          Niet gelukt…
        </button>
        <button
          type="button"
          onClick={onMoveClick}
          disabled={isLocked}
          title={isLocked ? 'Route is vergrendeld' : 'Verplaats naar andere route op deze dag'}
          className="px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Verplaatsen…
        </button>
      </div>
    </div>
  );
}
